<template>
    <div class="juhR-record" v-if="goodResultArt.length">

        <div class="right-tit">历史拍卖记录</div>

        <ul class="record-ul">
            <li class="last" v-for="(item,i) in goodResultArt" :key="i">
                <dl class="record-dl" :class="{'hoverBg':i == idx}" @mouseenter="hoverList(i)">
                    <dt>
                        <a :href="'/paimai-'+item.artCode" target="_blank" :title="item.show_title">
                        <template v-for="(m,k) in item.pc_extra_info">
                            <span v-if="m.label == 'lot号'" :key="k">{{m.text}}</span>
                        </template>
                        {{item.show_title}}
                        </a>
                    </dt>
                    <template v-for="(m,a) in item.pc_extra_info">
                        <dd :key="a" v-if="m.type == 'gujia'">估价:{{m.text}}</dd>
                    </template>
                    <template v-for="(m,b) in item.pc_extra_info">
                        <dd :key="b" v-if="m.type == 'price'">
                            成交价:
                            <template v-if="isLogin">
                                {{m.text!=''?m.text+m.smallText:'--'}}
                            </template>
                            <template v-else>
                                <a href="javascript:;" @click="gotoLogin">{{m.loginText}}</a>
                            </template>
                        </dd>
                    </template>
                    <template v-for="(m,c) in item.pc_extra_info">
                        <dd :key="c" v-if="m.type == 'company'">
                            {{m.text}}
                        </dd>
                    </template>
                    <dd>
                        <template v-for="(m,e) in item.detail.attribute">
                            <a :key="e" v-if="m.type=='session'" :href="'/meeting_detail/'+m.sessionCode" target="_blank">{{m.text}}</a>
                        </template>
                    </dd>
                    <dd class="record-img">
                        <a :href="'/paimai-'+item.artCode" target="_blank" :title="item.show_title"><img :src="item.coverPic" :alt="item.show_title" :title="item.show_title"></a>
                    </dd>
                </dl>
            </li>
        </ul>

    </div>
</template>

<script>
export default {
    name: "OrgRecord",
    props:['goodResultArt','isLogin','t'],
    data(){
        return{
            idx:0
        }
    },
    methods:{
        hoverList(i){
            this.idx = i;
        },
        gotoLogin(){
            window.location.href = '//passport.artron.net/login?appId=1&redirect='+encodeURIComponent(window.location.href)
        }
    }

}
</script>

<style scoped lang="scss">
.juhR-record {
    border: #e6e6e6 1px solid;
    margin-top: 10px;
    .right-tit {
        padding-left: 15px;
    }
}
.record-ul li {
    padding-bottom: 1px;
    zoom: 1;
    vertical-align: top;
    background: url(../../../assets/imgs/old/dot.png) repeat-x left bottom;
}
.record-ul li.last {
    background: none;
}
.record-dl {
    line-height: 20px;
    padding: 9px 19px 20px 19px;
    font-size: 12px;
    font-family: SimSun;
}
.hoverBg {
    background: #f0f0f0;
}
.hoverBg dt a {
    font-weight: bold;
    color: #0b59ac;
}
.hoverBg dt a:hover {
    text-decoration: underline;
}
.record-dl dt {
    font-weight: bold;
}
.record-dl dd a {
    color: #333333;
}
.record-dl dd a:hover {
    text-decoration: underline;
}
.record-img {
    margin-top: 5px;
    display: none;
}
.record-img a {
    width: 100%;
    height: 130px;
    border: #f0f0f0 1px solid;
    text-align: center;
    background: #ffffff;
    display: block;
}
.record-img a:hover{border:#b2cfed 1px solid;}
.record-img a img {
    vertical-align: middle;
    width:100%;height:100%;object-fit: contain;
}
.record-dl.hoverBg .record-img {
    display: block;
}
</style>